import { render } from "./SospensioniKOTable.vue?vue&type=template&id=5b6887f4&scoped=true"
import script from "./SospensioniKOTable.vue?vue&type=script&lang=js"
export * from "./SospensioniKOTable.vue?vue&type=script&lang=js"

import "./SospensioniKOTable.vue?vue&type=style&index=0&id=5b6887f4&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6887f4"]])

export default __exports__